import { BaseFormModeAdapter } from "./adapters";
import {
  FormConfiguration,
  SubmissionContext,
  FormInitParams,
} from "./definitions";
import { buildFormResetData } from "../util";
import { pluralize } from "utils/date-format";

/**
 * Adapter for Edit mode
 * Handles form behavior for editing existing Gaia objects
 */
export class EditAdapter extends BaseFormModeAdapter {
  /**
   * Initialize form data for edit mode
   */
  initializeFormData(params: FormInitParams): void {
    const { reset, transformedGaiaObject } = params;

    if (transformedGaiaObject) {
      reset(buildFormResetData(transformedGaiaObject));
    }
  }

  /**
   * Get form configuration for edit mode
   */
  getFormConfig(): FormConfiguration {
    return {
      ...super.getFormConfig(),
      // Edit mode specific overrides
      showTemplates: false,
      showFileUpload: false,
    };
  }

  shouldLoadGaiaObject(): boolean {
    return true;
  }

  getSubmitButtonText(): string {
    return "Save";
  }

  getSuccessRedirectPath(type: string, shortId?: string): string {
    return `/${pluralize(type)}/${shortId}`;
  }

  getCancelRedirectPath(type: string, shortId?: string): string {
    return `/${pluralize(type)}/${shortId}`;
  }

  /**
   * Handle edit submission
   * Flow: build update request → call updateGaiaObject hook
   */
  async handleSubmit(data: any, context: SubmissionContext): Promise<void> {
    if (context.ui.setDisableCreateEdit) {
      context.ui.setDisableCreateEdit(true);
    }

    try {
      // 1. Build update request (using component function)
      const updateRequest = context.transforms.buildUpdateRequest(data);

      // 2. Update GaiaObject (hook handles API + notification + navigation)
      await context.api.updateGaiaObject(updateRequest, context);
    } catch (error) {
      // Error handling is done in the hook
      throw error;
    }
  }
}
